(function() {
  if (window.LeonGroupifyBware) return;

  // ---------- Helpers ----------

  function parseJson(id) {
    try {
      var el = document.getElementById(id);
      return el ? JSON.parse(el.textContent) : {};
    } catch (e) {
      return {};
    }
  }

  function formatMoney(cents) {
    if (cents == null) return '';
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  // ---------- Tracking ----------

  // Hängt Query-Params an URL ohne bestehende Params zu zerstören.
  // Bewusst KEINE utm_*-Params (würde Marketing-Attribution überschreiben).
  function buildTrackedUrl(url, sourceHandle, position) {
    if (!url) return '#';
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('ref', 'bware-drawer');
      if (sourceHandle) u.searchParams.set('from', sourceHandle);
      if (position) u.searchParams.set('pos', String(position));
      // Pfad+Query zurückgeben (keine Domain, damit relative Links bleiben)
      return u.pathname + u.search + u.hash;
    } catch (e) {
      return url;
    }
  }

  // Pusht Event in window.dataLayer für GTM-Auswertung.
  // No-op wenn dataLayer fehlt — der Code bleibt sicher.
  function trackEvent(name, payload) {
    try {
      if (typeof window === 'undefined') return;
      window.dataLayer = window.dataLayer || [];
      var evt = { event: name };
      if (payload && typeof payload === 'object') {
        for (var k in payload) {
          if (Object.prototype.hasOwnProperty.call(payload, k)) {
            evt[k] = payload[k];
          }
        }
      }
      window.dataLayer.push(evt);
    } catch (e) { /* silent */ }
  }

  // Aktuelles Produkt aus URL ableiten (für `from`-Param).
  // Best-effort, kein Show-Stopper falls Pattern nicht matcht.
  function currentProductHandle() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : '';
  }

  // ---------- Globaler Cache ----------
  // Preise persistieren über mehrere Drawer-Opens hinweg
  var lgbPriceCache = {};

  // ---------- Drawer-Row HTML ----------

  function buildRowsHtml(items, t, sourceHandle) {
    // Sortierung: niedrigster Preis zuerst
    // (Drawer enthält ohnehin nur availableForSale-Items, daher keine OOS-Logik)
    items.sort(function(a, b) {
      var ap = a.price || 0;
      var bp = b.price || 0;
      if (!ap && bp) return 1;
      if (ap && !bp) return -1;
      return ap - bp;
    });

    return items.map(function(item, idx) {
      var position = idx + 1;
      var trackedUrl = buildTrackedUrl(item.url, sourceHandle, position);
      var thumb = item.image
        ? '<img src="' + item.image + '" alt="' + (item.title || '').replace(/"/g, '&quot;') + '" loading="lazy" width="80" height="80">'
        : '';
      var badge = '<span class="lgb-d-badge lgb-d-badge--avail"><span class="lgb-d-dot"></span>' + t.available + '</span>';

      // Preis: Hybrid – Server-Preis (Liquid) vorhanden, JS aktualisiert ggf.
      var priceHtml = (item.price && item.price > 0)
        ? '<span class="lgb-price" data-handle="' + (item.handle || '') + '">' + (item.price_formatted || formatMoney(item.price)) + '</span>'
        : '<span class="lgb-price lgb-price-loading" data-handle="' + (item.handle || '') + '">–</span>';

      var priceAttr = (item.price && item.price > 0) ? ' data-price="' + item.price + '"' : '';

      return '<tr class="lgb-d-row"' + priceAttr
        + ' data-href="' + trackedUrl + '"'
        + ' data-handle="' + (item.handle || '') + '"'
        + ' data-position="' + position + '"'
        + ' tabindex="0" role="link" aria-label="' + (item.title || '').replace(/"/g, '&quot;') + '">'
        + '<td class="lgb-d-td lgb-d-td--thumb"><div class="lgb-d-thumb"><div class="lgb-d-thumb-img">' + thumb + '</div></div></td>'
        + '<td class="lgb-d-td lgb-d-td--title">'
        +   (item.vendor ? '<p class="lgb-d-vendor">' + item.vendor + '</p>' : '')
        +   '<p class="lgb-d-title">' + (item.title || '') + '</p>'
        + '</td>'
        + '<td class="lgb-d-td lgb-d-td--price">' + priceHtml + '</td>'
        + '<td class="lgb-d-td lgb-d-td--avail">' + badge + '</td>'
        + '<td class="lgb-d-td lgb-d-td--action">'
        +   '<a href="' + trackedUrl + '" class="lgb-d-view-btn" tabindex="-1" aria-hidden="true">'
        +     '<svg viewBox="0 0 24 24" width="12" height="12" stroke="currentColor" fill="none" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M12 5l7 7-7 7"/></svg>'
        +     '<span class="lgb-d-view-label">' + t.view_product + '</span>'
        +   '</a>'
        + '</td>'
        + '</tr>';
    }).join('');
  }

  // ---------- Price-Refresh & Trigger-Update ----------

  // Lädt Preise per /products/{handle}.js (max 4 parallel) und korrigiert
  // sowohl Drawer-Rows als auch den Trigger-Text (Count + Min-Preis).
  // - Items die nicht mehr availableForSale sind → aus Drawer + Count entfernen
  // - Min-Preis neu berechnen auf Basis der live verfügbaren Items
  function refreshFromStorefront(uid, t, items, onTriggerUpdate) {
    if (!items || !items.length) return;

    var CONCURRENCY = 4;
    var idx = 0;
    var completed = 0;
    var liveData = {}; // handle → { price, available }

    function applyAndRecompute() {
      var drawer = document.getElementById('lgb-drawer-' + uid);
      var tbody = document.getElementById('lgb-d-tbody-' + uid);

      var liveAvailableItems = [];

      items.forEach(function(item) {
        var live = liveData[item.handle];
        // Fallback: wenn API-Fetch fehlgeschlagen ist, gehen wir vom Liquid-Wert aus
        var isAvail = live ? live.available : item.available;
        var price = live && live.price ? live.price : item.price;

        if (isAvail) {
          liveAvailableItems.push({ handle: item.handle, price: price });
        }

        // Drawer-Row aktualisieren (falls Drawer schon gebaut)
        if (tbody) {
          var row = tbody.querySelector('tr[data-handle="' + item.handle + '"]');
          if (row) {
            if (!isAvail) {
              row.parentNode.removeChild(row);
            } else if (price) {
              row.setAttribute('data-price', price);
              var priceEl = row.querySelector('.lgb-price');
              if (priceEl) {
                priceEl.textContent = formatMoney(price);
                priceEl.classList.remove('lgb-price-loading');
              }
            }
          }
        }
      });

      // Drawer-Rows nach Preis aufsteigend re-sortieren
      if (tbody) {
        var rows = Array.from(tbody.querySelectorAll('tr.lgb-d-row'));
        if (rows.length > 1) {
          rows.sort(function(a, b) {
            var ap = parseInt(a.getAttribute('data-price') || '0', 10);
            var bp = parseInt(b.getAttribute('data-price') || '0', 10);
            return ap - bp;
          });
          var frag = document.createDocumentFragment();
          rows.forEach(function(r) { frag.appendChild(r); });
          tbody.appendChild(frag);
        }

        // Empty-State falls alle Items nicht mehr verfügbar
        if (!tbody.querySelector('tr.lgb-d-row')) {
          var emptyTr = document.createElement('tr');
          emptyTr.innerHTML = '<td colspan="5" class="lgb-d-empty">' + (t.empty_state || 'Aktuell keine Gebraucht-Artikel auf Lager.') + '</td>';
          tbody.appendChild(emptyTr);
        }
      }

      // Trigger neu berechnen
      var count = liveAvailableItems.length;
      var minPrice = 0;
      liveAvailableItems.forEach(function(i) {
        if (i.price && (minPrice === 0 || i.price < minPrice)) minPrice = i.price;
      });

      if (typeof onTriggerUpdate === 'function') {
        onTriggerUpdate(count, minPrice);
      }
    }

    function next() {
      if (idx >= items.length) return;
      var item = items[idx++];
      var handle = item.handle;

      if (lgbPriceCache[handle]) {
        liveData[handle] = lgbPriceCache[handle];
        completed++;
        if (completed === items.length) applyAndRecompute();
        next();
        return;
      }

      fetch('/products/' + handle + '.js')
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(data) {
          if (data) {
            var entry = {
              price: data.price_min || data.price || 0,
              available: !!data.available
            };
            lgbPriceCache[handle] = entry;
            liveData[handle] = entry;
          }
        })
        .catch(function() { /* silent */ })
        .then(function() {
          completed++;
          if (completed === items.length) applyAndRecompute();
          next();
        });
    }

    for (var i = 0; i < Math.min(CONCURRENCY, items.length); i++) next();
  }

  // ---------- Drawer-CSS (inline, on-demand) ----------

  function buildDrawerCss(drawerId, uid) {
    return [
      '#' + drawerId + ' *{box-sizing:border-box;}',
      '#' + drawerId + ' #lgb-d-body-' + uid + '{border-top:1px solid rgba(0,0,0,.08);}',
      '#' + drawerId + ' .lgb-tbl{width:100%;border-collapse:collapse;table-layout:fixed;}',
      '#' + drawerId + ' .lgb-tbl colgroup col:nth-child(1){width:60px;}',
      '#' + drawerId + ' .lgb-tbl colgroup col:nth-child(2){width:auto;}',
      '#' + drawerId + ' .lgb-tbl colgroup col:nth-child(3){width:86px;}',
      '#' + drawerId + ' .lgb-tbl colgroup col:nth-child(4){width:108px;}',
      '#' + drawerId + ' .lgb-tbl colgroup col:nth-child(5){width:92px;}',
      '#' + drawerId + ' .lgb-tbl thead th{position:sticky;top:0;z-index:1;background:#f5f5f7;padding:9px 8px;font-size:10px;font-weight:600;color:#888;text-align:left;text-transform:uppercase;letter-spacing:.5px;border-top:none;border-bottom:1px solid rgba(0,0,0,.07);overflow:hidden;white-space:nowrap;text-overflow:ellipsis;}',
      '#' + drawerId + ' .lgb-tbl thead th:first-child{padding-left:12px;}',
      '#' + drawerId + ' .lgb-tbl thead th:last-child{text-align:right;padding-right:12px;}',
      '#' + drawerId + ' .lgb-d-row{border-bottom:1px solid rgba(0,0,0,.06);cursor:pointer;transition:background .15s;}',
      '#' + drawerId + ' .lgb-d-row:last-child{border-bottom:none;}',
      '#' + drawerId + ' .lgb-d-row:hover{background:rgba(0,0,0,.025);}',
      '#' + drawerId + ' .lgb-d-row:focus-visible{outline:2px solid #0171e2;outline-offset:-2px;}',
      '#' + drawerId + ' .lgb-d-td{padding:11px 8px;vertical-align:middle;overflow:hidden;}',
      '#' + drawerId + ' .lgb-d-td:first-child{padding-left:12px;}',
      '#' + drawerId + ' .lgb-d-td:last-child{padding-right:12px;text-align:right;}',
      '#' + drawerId + ' .lgb-d-thumb{width:44px;height:44px;border-radius:6px;overflow:hidden;background:#f0f0f0;display:flex;align-items:center;justify-content:center;flex-shrink:0;}',
      '#' + drawerId + ' .lgb-d-thumb img{width:100%;height:100%;object-fit:contain;display:block;}',
      '#' + drawerId + ' .lgb-d-vendor{font-size:10px;color:#bbb;margin:0 0 2px;line-height:1;}',
      '#' + drawerId + ' .lgb-d-title{font-size:12.5px;font-weight:400;color:#1a1a1a;line-height:1.35;overflow-wrap:break-word;word-break:break-word;margin:0;}',
      '#' + drawerId + ' .lgb-d-td--price{font-size:13px;font-weight:700;color:#111;white-space:nowrap;}',
      '#' + drawerId + ' .lgb-d-badge{display:inline-flex;align-items:center;gap:3px;font-size:10.5px;font-weight:500;padding:3px 7px;border-radius:999px;white-space:nowrap;}',
      '#' + drawerId + ' .lgb-d-badge--avail{background:rgba(34,197,94,.12);color:#16a34a;}',
      '#' + drawerId + ' .lgb-d-dot{width:5px;height:5px;border-radius:50%;flex-shrink:0;background:#22c55e;}',
      '#' + drawerId + ' .lgb-d-view-btn{display:inline-flex;align-items:center;gap:3px;font-size:11px;font-weight:600;color:#0171e2;background:rgba(1,113,226,.08);border:none;border-radius:6px;padding:5px 8px;cursor:pointer;text-decoration:none;white-space:nowrap;transition:background .15s;max-width:100%;}',
      '#' + drawerId + ' .lgb-d-view-btn:hover{background:rgba(1,113,226,.16);}',
      '#' + drawerId + ' .lgb-d-empty{padding:32px 16px;text-align:center;color:#888;font-size:13px;}',
      '@media(max-width:749px){'
        + '#' + drawerId + ' .lgb-tbl{width:calc(100% - 2px);margin:0 0 0 1px;}'
        + '#' + drawerId + ' .lgb-tbl colgroup col:nth-child(1){width:58px;}'
        + '#' + drawerId + ' .lgb-tbl colgroup col:nth-child(2){width:100%;}'
        + '#' + drawerId + ' .lgb-tbl colgroup col:nth-child(3){width:68px;}'
        + '#' + drawerId + ' .lgb-tbl colgroup col:nth-child(4){width:0;display:none;}'
        + '#' + drawerId + ' .lgb-tbl colgroup col:nth-child(5){width:44px;}'
        + '#' + drawerId + ' .lgb-tbl thead th:nth-child(4){display:none;}'
        + '#' + drawerId + ' .lgb-d-td:nth-child(4){display:none;}'
        + '#' + drawerId + ' .lgb-d-view-label{display:none;}'
        + '#' + drawerId + ' .lgb-d-view-btn{padding:0;border-radius:50%;width:32px;height:32px;justify-content:center;flex-shrink:0;}'
        + '#' + drawerId + ' .lgb-d-td{padding:9px 6px;vertical-align:middle;}'
        + '#' + drawerId + ' .lgb-d-td:first-child{padding-left:14px;}'
        + '#' + drawerId + ' .lgb-d-td:last-child{padding-right:6px;}'
        + '#' + drawerId + ' .lgb-d-thumb{width:40px;height:40px;}'
        + '#' + drawerId + ' .lgb-d-title{font-size:12px;}'
        + '#' + drawerId + ' thead th{padding:8px 6px;}'
        + '#' + drawerId + ' thead th:first-child{padding-left:14px;}'
        + '#' + drawerId + ' thead th:last-child{padding-right:6px;}'
      + '}'
    ].join('');
  }

  // ---------- Trigger-Update ----------

  function updateTrigger(trigger, count, minPrice) {
    if (!trigger) return;
    var countEl = trigger.querySelector('[data-lgb-count]');
    var priceEl = trigger.querySelector('[data-lgb-min-price]');

    if (count === 0) {
      // Sollte praktisch nie passieren (Liquid hat min. 1 verfügbar gerendert),
      // aber sauberer Fallback: Trigger ausblenden
      trigger.hidden = true;
      trigger.setAttribute('aria-hidden', 'true');
      return;
    }

    if (countEl) countEl.textContent = '(' + count + ')';
    if (priceEl && minPrice) priceEl.textContent = formatMoney(minPrice);
  }

  // ---------- Drawer-Init ----------

  function initTrigger(trigger) {
    if (!trigger || trigger.dataset.lgbInit) return;
    trigger.dataset.lgbInit = '1';

    var uid = trigger.getAttribute('data-lgb-uid');
    var t = parseJson('lgb-locale-' + uid);
    // Defensive Fallbacks – falls Locale-File mal fehlt oder Translation leer ist.
    // Locale-Keys werden vom Liquid-Snippet befüllt (snippets.groupify_variants.* + snippets.groupify_bware.*)
    t.close_btn    = t.close_btn    || 'Schließen';
    t.col_variant  = t.col_variant  || 'Variante';
    t.col_price    = t.col_price    || 'Preis';
    t.col_avail    = t.col_avail    || 'Zustand';
    t.available    = t.available    || 'Auf Lager';
    t.unavailable  = t.unavailable  || 'Nicht verfügbar';
    t.view_product = t.view_product || 'Ansehen';
    t.empty_state  = t.empty_state  || 'Aktuell keine Gebraucht-Artikel auf Lager.';

    var data = parseJson('lgb-data-' + uid);
    var items = (data.items || []).slice();

    // --- Drawer-Build & Lifecycle ---
    var drawer = null;
    var overlay = null;
    var drawerBuilt = false;
    var storefrontRefreshed = false; // Refresh feuert nur EINMAL beim ersten Open
    var DRAWER_ID = 'lgb-drawer-' + uid;
    var OVERLAY_ID = 'lgb-overlay-' + uid;

    function buildDrawer() {
      if (drawerBuilt) return;
      drawerBuilt = true;

      var freshData = parseJson('lgb-data-' + uid);
      var freshItems = (freshData.items || []).slice();
      var sourceHandle = currentProductHandle();
      var rowsHtml = buildRowsHtml(freshItems, t, sourceHandle);
      var isMobile = window.innerWidth <= 749;

      overlay = document.createElement('div');
      overlay.id = OVERLAY_ID;
      overlay.setAttribute('aria-hidden', 'true');
      overlay.className = 'lgb-d-overlay';
      overlay.style.cssText = [
        'position:fixed', 'inset:0', 'background:rgba(0,0,0,0.42)',
        'z-index:9000', 'opacity:0', 'visibility:hidden',
        'transition:opacity .32s cubic-bezier(.4,0,.2,1),visibility .32s cubic-bezier(.4,0,.2,1)',
        '-webkit-backdrop-filter:blur(2px)', 'backdrop-filter:blur(2px)'
      ].join(';');

      drawer = document.createElement('aside');
      drawer.id = DRAWER_ID;
      drawer.setAttribute('role', 'dialog');
      drawer.setAttribute('aria-modal', 'true');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('aria-labelledby', 'lgb-d-title-' + uid);
      drawer.style.cssText = isMobile ? [
        'position:fixed',
        'top:8px', 'bottom:8px', 'left:8px', 'right:8px',
        'width:calc(100vw - 16px)',
        'height:calc(100dvh - 16px)',
        'max-height:calc(100dvh - 16px)',
        'background:#fff',
        'z-index:9001', 'display:flex', 'flex-direction:column',
        'transform:translateY(calc(100vh + 20px))',
        'transition:transform .36s cubic-bezier(.4,0,.2,1)',
        'border-radius:16px',
        'overflow:hidden', 'font-family:"DM Sans",sans-serif',
        'box-shadow:0 4px 32px rgba(0,0,0,0.22)'
      ].join(';') : [
        'position:fixed', 'top:0', 'right:0', 'bottom:0',
        'width:min(480px,100vw)', 'background:#fff',
        'z-index:9001', 'display:flex', 'flex-direction:column',
        'transform:translateX(100%)',
        'transition:transform .36s cubic-bezier(.4,0,.2,1)',
        'overflow:hidden', 'font-family:"DM Sans",sans-serif',
        'box-shadow:-4px 0 24px rgba(0,0,0,0.12)'
      ].join(';');

      drawer.innerHTML = [
        '<div style="display:flex;justify-content:center;padding:10px 0 0;flex-shrink:0;"><div style="width:36px;height:4px;background:rgba(0,0,0,0.15);border-radius:99px;"></div></div>',
        '<div style="display:flex;align-items:center;justify-content:space-between;padding:14px 20px 14px;flex-shrink:0;">',
          '<h2 id="lgb-d-title-' + uid + '" style="margin:0;font-size:16px;font-weight:600;color:#1a1a1a;letter-spacing:-0.3px;font-family:inherit;">' + (freshData.label || '') + '</h2>',
          '<button id="lgb-d-close-' + uid + '" type="button" aria-label="' + t.close_btn + '" style="display:flex!important;align-items:center!important;justify-content:center!important;width:32px!important;min-width:32px!important;max-width:32px!important;height:32px!important;min-height:32px!important;max-height:32px!important;border:none!important;background:rgba(0,0,0,0.06)!important;border-radius:50%!important;cursor:pointer!important;color:#555!important;transition:background .18s!important;flex-shrink:0!important;padding:0!important;box-sizing:content-box!important;appearance:none!important;-webkit-appearance:none!important;box-shadow:none!important;">',
            '<svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
          '</button>',
        '</div>',
        '<div id="lgb-d-body-' + uid + '" style="flex:1;overflow-y:auto;overscroll-behavior:contain;padding:0;">',
          '<style>' + buildDrawerCss(DRAWER_ID, uid) + '</style>',
          '<table class="lgb-tbl"><colgroup><col><col><col><col><col></colgroup>',
          '<thead><tr><th style="width:60px;" aria-label="Bild"></th><th>' + t.col_variant + '</th><th style="white-space:nowrap;">' + t.col_price + '</th><th style="white-space:nowrap;">' + t.col_avail + '</th><th></th></tr></thead>',
          '<tbody id="lgb-d-tbody-' + uid + '">' + rowsHtml + '</tbody></table>',
        '</div>'
      ].join('');

      document.body.appendChild(overlay);
      document.body.appendChild(drawer);

      // Row-Click Delegation
      var tbody = document.getElementById('lgb-d-tbody-' + uid);
      if (tbody) {
        tbody.querySelectorAll('tr[data-href]').forEach(function(row) {
          var handle = row.getAttribute('data-handle') || '';
          var position = parseInt(row.getAttribute('data-position') || '0', 10);
          var price = parseInt(row.getAttribute('data-price') || '0', 10) || null;

          function fireClickEvent() {
            trackEvent('bware_drawer_click', {
              source_product: sourceHandle,
              target_product: handle,
              target_price: price,
              position: position
            });
          }

          function go() {
            var href = row.getAttribute('data-href');
            fireClickEvent();
            if (href) window.location.href = href;
          }
          row.addEventListener('click', function(e) {
            // a-Tag-Klick: Event feuern, Navigation übernimmt der Browser via href
            if (e.target.closest('a')) {
              fireClickEvent();
              return;
            }
            go();
          });
          row.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              go();
            }
          });
        });
      }

      // Close-Button
      var closeBtn = document.getElementById('lgb-d-close-' + uid);
      if (closeBtn) {
        closeBtn.addEventListener('click', closeDrawer);
        closeBtn.addEventListener('mouseover', function() {
          closeBtn.style.setProperty('background', 'rgba(0,0,0,.12)', 'important');
        });
        closeBtn.addEventListener('mouseout', function() {
          closeBtn.style.setProperty('background', 'rgba(0,0,0,.06)', 'important');
        });
      }

      // Backdrop-Click
      overlay.addEventListener('click', closeDrawer);

      // Focus-Trap
      drawer.addEventListener('keydown', function(e) {
        if (e.key !== 'Tab') return;
        var focusable = Array.from(drawer.querySelectorAll('button:not([disabled]),[href],input,select,textarea,[tabindex]:not([tabindex="-1"])'));
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      });
    }

    function openDrawer() {
      buildDrawer();

      // Tracking: Drawer wurde geöffnet (Funnel-Top)
      trackEvent('bware_drawer_open', {
        source_product: currentProductHandle(),
        available_count: items.length
      });

      // Storefront-Refresh läuft nur EINMAL beim ersten Open – kein Page-Load-Traffic
      if (!storefrontRefreshed) {
        storefrontRefreshed = true;
        refreshFromStorefront(uid, t, items, function(count, minPrice) {
          updateTrigger(trigger, count, minPrice);
        });
      }

      overlay.style.opacity = '1';
      overlay.style.visibility = 'visible';
      overlay.style.pointerEvents = 'auto';
      overlay.setAttribute('aria-hidden', 'false');
      drawer.style.setProperty('transform', 'none', 'important');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function() {
        var cb = document.getElementById('lgb-d-close-' + uid);
        if (cb) cb.focus();
      }, 360);
    }

    function closeDrawer() {
      if (!drawer || !overlay) return;
      overlay.style.opacity = '0';
      overlay.style.visibility = 'hidden';
      overlay.style.pointerEvents = 'none';
      overlay.setAttribute('aria-hidden', 'true');
      drawer.style.setProperty(
        'transform',
        window.innerWidth <= 749 ? 'translateY(calc(100vh + 20px))' : 'translateX(100%)',
        'important'
      );
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      trigger.focus();
    }

    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      openDrawer();
    });
    trigger.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        e.stopImmediatePropagation();
        openDrawer();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer && drawer.getAttribute('aria-hidden') === 'false') {
        closeDrawer();
      }
    });
  }

  // ---------- Boot ----------

  function boot() {
    document.querySelectorAll('[data-lgb-trigger]').forEach(initTrigger);
  }

  // MutationObserver für per AJAX nachgeladene Trigger (z. B. Recommendations)
  function observeNew() {
    if (typeof MutationObserver === 'undefined') return;
    var debounceTimer = null;
    var observer = new MutationObserver(function(mutations) {
      var hasNew = false;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (
            (node.hasAttribute && node.hasAttribute('data-lgb-trigger')) ||
            (node.querySelector && node.querySelector('[data-lgb-trigger]'))
          ) {
            hasNew = true;
            break;
          }
        }
        if (hasNew) break;
      }
      if (hasNew) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(boot, 80);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      boot();
      observeNew();
    });
  } else {
    boot();
    observeNew();
  }
  document.addEventListener('shopify:section:load', boot);

  window.LeonGroupifyBware = { boot: boot };
})();